import React from 'react';
import cx from 'classnames';
import {Modal, Slide} from '@mui/material';
import {Link} from 'gatsby';
import {Backdrop} from 'src/components/backdrop';
import {MenuItem} from 'src/components/menu-item';
import {
	useStoreContext,
	useToggleMenu,
	useSetActiveSubmenu,
	useToggleCart,
} from 'src/context/storeContext';

import {getInternalLinkPath} from 'src/utils/getInternalLinkPath';

import * as styles from './mobile-menu.module.css';

export const MobileMenu = ({data}) => {
	const {
		primaryMenu,
		secondaryMenu,
		additionalLinkTarget,
		additionalLinkLabel,
		additionalLinkTitle,
	} = data;
	const {menuIsOpen, cartIsOpen, noticeBarVisible} = useStoreContext();
	const toggleMenu = useToggleMenu();
	const toggleCart = useToggleCart();

	const handleMenuItemClick = (event, item) => {
		cartIsOpen && toggleCart();
		menuIsOpen && toggleMenu();
	};

	return (
		<Modal
			open={menuIsOpen}
			onClose={() => toggleMenu()}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{active: menuIsOpen, toggle: toggleMenu}}
			style={{zIndex: '1100'}}
			aria-modal="true"
			aria-labelledby="mobileMenuLabel">
			<Slide
				in={menuIsOpen}
				direction="left"
				timeout={{
					enter: 400,
					exit: 250,
				}}>
				<div
					className={cx(
						styles.drawer,
						noticeBarVisible ? styles.noticeBarVisible : '',
					)}
					role="presentation">
					<div className={styles.drawerInner}>
						<h2 id="mobileMenuLabel" className="visually-hidden">
							Menu
						</h2>
						<ul className={cx(styles.menuList)} role="menu">
							{primaryMenu &&
								primaryMenu.items.map((item, index) => (
									<MenuItem
										className={cx(
											'headline c-gold',
											styles.menuItem,
											menuIsOpen ? styles.reveal : '',
										)}
										item={item}
										key={item._key}
										clickHandler={event =>
											handleMenuItemClick(event, item)
										}
										style={{
											'--delay': `${index * 40 + 160}ms`,
										}}>
										<span className="underline-on-hover">
											{item.title}
										</span>
									</MenuItem>
								))}
						</ul>
						<ul className={cx(styles.menuList)} role="menu">
							{secondaryMenu &&
								secondaryMenu.items.map((item, index) => (
									<MenuItem
										className={cx(
											'default c-gold',
											styles.menuItem,
											menuIsOpen ? styles.reveal : '',
										)}
										item={item}
										key={item._key}
										clickHandler={event =>
											handleMenuItemClick(event, item)
										}
										style={{
											'--delay': `${
												(primaryMenu.items.length +
													index) *
													40 +
												160
											}ms`,
										}}>
										<span className="underline-on-hover">
											{item.title}
										</span>
									</MenuItem>
								))}
						</ul>
						{additionalLinkTarget && (
							<div
								className={cx(
									styles.additionalLinkContainer,
									menuIsOpen ? styles.reveal : '',
								)}
								style={{
									'--delay': `${
										(primaryMenu.items.length +
											secondaryMenu.items.length) *
											40 +
										160
									}ms`,
								}}>
								<Link
									className={cx(
										'c-gold',
										styles.additionalLink,
									)}
									to={getInternalLinkPath(
										additionalLinkTarget.link,
									)}
									onClick={toggleMenu}>
									<span
										className={cx(
											'label-italic',
											styles.additionalLinkLabel,
										)}>
										{additionalLinkLabel}
									</span>
									<span
										className={cx(
											'label-caps underline-on-hover',
										)}>
										{additionalLinkTitle}
									</span>
								</Link>
							</div>
						)}
					</div>
				</div>
			</Slide>
		</Modal>
	);
};
